import type { ValidationData } from '@wix/editor-elements-corvid-utils';
import { addErrorToValidationDataAndKeepMessage } from '@wix/editor-elements-corvid-utils';
import type { InternalAddress } from '../../../providers/useAtlasHandler/types';

export const validateRequiredAddress = (
  props: {
    required: boolean;
    value?: InternalAddress;
  },
  validationData: ValidationData,
): ValidationData => {
  const isRequired = props.required || false;

  if (!isRequired || (props.value && props.value.formatted)) {
    return validationData;
  }

  return addErrorToValidationDataAndKeepMessage(validationData, 'valueMissing');
};
